/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_No_Limit_ChipInputs */



/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Usage_Overage_No_Limit_ChipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_no_limit_chip = /** @type {((inputs?: Usage_Overage_No_Limit_ChipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_No_Limit_ChipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Limit")
	return /** @type {LocalizedString} */ ("No limit")
});